import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Chat from "./components/Chat";
import CookiesBanner from "./components/CookiesBanner";
import NotFound from "./components/NotFound";
import "./index.css";

function MainPage() {
  return (
    <>
      <Hero />
      <About />
      <Skills />
      <Contact />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      {/* <div className="blur-top" /> */}
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      {/* <div className="blur-bottom" /> */}
      <Chat />
      <CookiesBanner />
    </BrowserRouter>
  );
}

export default App;
